import "./ballsColor.css";

interface BallsColorPage {
  titleStatus: string | undefined;
  colorStatus: string;
}

const BallsColor = ({ titleStatus, colorStatus }: BallsColorPage) => {
  const buttonStyle = {
    backgroundColor: colorStatus,
  };

  return (
    <>
      <div className="StatusColors">
        <div
          className="ballsColor"
          style={buttonStyle}
          data-testid="ball-color"
        ></div>
        <div className="statusCurrent">
          <span data-testid="status-title">{titleStatus}</span>
        </div>
      </div>
    </>
  );
};

export default BallsColor;
